import { useController, useWatch } from 'react-hook-form';

import { Dropdown, Stack, Text, TextInput } from '@ekhodealer/ekho-common/rev';

const PRESET_DURATIONS = [15, 20, 30, 45, 60, 90, 120];

const DURATION_OPTIONS = [
	{ id: '15', label: '15 minutes' },
	{ id: '20', label: '20 minutes' },
	{ id: '30', label: '30 minutes' },
	{ id: '45', label: '45 minutes' },
	{ id: '60', label: '1 hour' },
	{ id: '90', label: '1.5 hours' },
	{ id: '120', label: '2 hours' },
	{ id: 'custom', label: 'Custom' },
];

interface DurationSelectorProps {
	schemaField: string;
	isDisabled?: boolean;
}

export function DurationSelector({ schemaField, isDisabled }: DurationSelectorProps) {
	const { field } = useController({ name: schemaField, shouldUnregister: false });
	const currentValue = useWatch({ name: schemaField }) as number | undefined;

	const numericValue = currentValue ?? 30;
	const isPreset = PRESET_DURATIONS.includes(numericValue);
	const dropdownValue = isPreset ? String(numericValue) : 'custom';

	const handleSelectionChange = (value: string) => {
		if (value === 'custom') {
			if (isPreset) field.onChange(25);
		} else {
			field.onChange(Number(value));
		}
	};

	const handleCustomChange = (value: string) => {
		const num = Number(value);
		if (!isNaN(num) && num >= 5 && num <= 240) {
			field.onChange(num);
		}
	};

	return (
		<Stack itemsSpacing='8'>
			<Text size='bodySmall' weight='semibold'>
				Appointment duration
			</Text>
			<Dropdown
				options={DURATION_OPTIONS}
				value={dropdownValue}
				onSelectionChange={handleSelectionChange}
				placeholder='Select duration'
				size='large'
				disabled={isDisabled}
			/>
			{!isPreset && (
				<TextInput
					type='number'
					value={String(numericValue)}
					onChange={handleCustomChange}
					onBlur={() => field.onBlur()}
					isDisabled={isDisabled}
					placeholder='Minutes'
					size='large'
					rightContent={
						<Text size='bodySmall' color='secondary'>
							min
						</Text>
					}
				/>
			)}
		</Stack>
	);
}
